module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_search_place-43f1bd294ee65d4f7ffb464da2e8b60a.svg";